module.exports = __webpack_public_path__ + "static/img/M-4.dbc7f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/M-4.png
// module id = vkwl
// module chunks = 0